'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _genericResult = require('./generic-result.scss');

var _genericResult2 = _interopRequireDefault(_genericResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    type: _propTypes2.default.string,
    index: _propTypes2.default.number,
    highlightIndex: _propTypes2.default.number,
    getContainerRect: _propTypes2.default.func.isRequired,
    scrollIntoView: _propTypes2.default.func.isRequired
};

var defaultProps = {
    type: 'div',
    index: undefined,
    highlightIndex: -1
};

var GenericResult = function (_React$PureComponent) {
    _inherits(GenericResult, _React$PureComponent);

    function GenericResult() {
        _classCallCheck(this, GenericResult);

        return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
    }

    GenericResult.prototype.componentDidUpdate = function componentDidUpdate() {
        var visibleOffset = void 0;
        if (this.isHighlighted()) {
            visibleOffset = this.getVisibilityOffset();
            if (visibleOffset) {
                this.props.scrollIntoView(visibleOffset);
            }
        }
    };

    GenericResult.prototype.getVisibilityOffset = function getVisibilityOffset() {
        var row = this.node.getBoundingClientRect();
        var container = this.props.getContainerRect();
        if (row.bottom > container.bottom) {
            return row.bottom - container.bottom;
        } else if (row.top < container.top) {
            return row.top - container.top;
        }
        return 0;
    };

    GenericResult.prototype.isHighlighted = function isHighlighted() {
        return this.props.index === this.props.highlightIndex;
    };

    GenericResult.prototype.render = function render() {
        var _classNames,
            _this2 = this;

        var omitProperties = function omitProperties(obj, properties) {
            var scopedObj = Object.assign({}, obj);
            properties.forEach(function (property) {
                return delete scopedObj[property];
            });
            return scopedObj;
        };
        var overriddenProps = Object.assign({}, omitProperties(this.props, ['type', 'index', 'highlightIndex', 'getContainerRect', 'scrollIntoView', 'children']), {
            className: (0, _classnames2.default)(_genericResult2.default.categoryResult, (_classNames = {}, _classNames[_genericResult2.default.highlight] = this.isHighlighted(), _classNames)),
            ref: function ref(node) {
                _this2.node = node;
            },
            'data-auto-output': 'results:item'
        });
        return _react2.default.createElement(this.props.type, overriddenProps, this.props.children);
    };

    return GenericResult;
}(_react2.default.PureComponent);

exports.default = GenericResult;


GenericResult.propTypes = propTypes;
GenericResult.defaultProps = defaultProps;